/**
 * @module app.filter
 */
import appBase from './index.js';

appBase.filter('replaceIfEmpty', function() {
  return function(value, replacement = '-') {
    value = typeof value === 'string' ? value.trim() : value;
    return value ? value : replacement;
  };
});

appBase.filter('daysOffset', function() {
  return function(value) {
    const today = new Date();
    return today.setHours(today.getHours() + value * 24);
  };
});

// format a distance in meters or kilometers
appBase.filter('distance', ['$filter', function(filter) {
  const number = filter('number');
  const decoratedNumber = function(value, fracSize, unit) {
    if (value === undefined) {
      return '';
    }
    value = value.toFixed(fracSize);
    const abs = Math.abs(value);
    const integerPart = Math.floor(abs) * (value < 0 ? -1 : 1);
    const decimalPart = abs % 1;
    const integerPartString = number(integerPart, 0);
    let result = integerPartString.replace('.', '\'').replace(',', '\'');
    if (decimalPart > 0) {
      result += '.' + decimalPart.toFixed(fracSize).substring(2);
    }
    return result + ' ' + unit;
  };

  return function(m, collapse) {
    const km = m / 1000;
    const fracSize = collapse ? 2 : 0;
    if (collapse && km > 0) {
      return decoratedNumber(km, fracSize, 'km');
    } else {
      return decoratedNumber(m, fracSize, 'm');
    }
  };
}]);

// format a duration in minutes
appBase.filter('duration', function() {
  return function(input) {
    const m = Math.round(input);
    const hour = Math.floor(m / 60);
    const min = Math.round(m - hour * 60);
    return hour + ' h ' + min + ' min';
  };
});

// format a duration in minutes
appBase.filter('durationStd', function() {
  return function(input) {
    input = Number(input);
    if (!input || isNaN(input)) {
      return '';
    }
    const m = Math.round(input);
    const hour = Math.floor(m / 60);
    const min = Math.round(m - hour * 60);
    return `${hour}${min > 0 ? `:${min}` : ''}`;
  };
});

//remove '( 0 )' from phone number
appBase.filter('phone', function() {
  return function(textPhoneNumber) {
    return textPhoneNumber.replace(/\(\s*0\s*\)/, '');
  };
});

// format a number as a scale
appBase.filter('scalify', ['$filter', function(filter) {
  const number = filter('number');
  return function(scale) {
    const text = number(scale, 0);
    return '1 : ' + text.replace(/,/g, "'");
  };
}]);

appBase.filter('trustedHtml', ['$sce', function($sce) {
  return function(value) {
    return $sce.trustAsHtml(value);
  };
}]);

// format a speed in km/h
appBase.filter('speed', function() {
  return function(input) {
    const speed = Math.round(input);
    return isNaN(speed) ? '-' : `${speed} km/h`;
  };
});
